import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { QrReader } from 'react-qr-reader';
import { Box, Button, CircularProgress,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
  Card,
  Grid,
  Typography,
  Select,
  MenuItem,
  InputAdornment,
  Menu,
  CardContent,
  ToggleButton, ToggleButtonGroup, Chip
 } from "@mui/material";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useStyles } from "./../../../theme/appStyles";
import LogoMain from "../../../Images/logo_main_black.webp";
import {
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import {
  IProductPopUP,
  IInvoice,
  IOrderTicket,
} from "../../../Api/Interface/api.interface";
import dayjs from "dayjs";
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import { CiSearch } from "react-icons/ci";
import Pagination from "../../../Components/Pagination";
import { useNotifier } from "../../../Core/Notifier";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import PeopleIcon from "@mui/icons-material/People";
import InsightsIcon from "@mui/icons-material/Insights";
import EditIcon from "@mui/icons-material/Edit";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventIcon from "@mui/icons-material/Event";

interface Ticket {
  id: number;
  order_id: number;
  event_id: number;
  ticket_code: string;
  qr_token: string;
  qr_path: string;
  booked_quantity: number;
  used_quantity: number;
  status: string;
  event_name?: string;
  customer_name?: string;
  invoice_no?: string;    
  created_at?: string;
  scanned_by?: string;
  scanned_at?:string;
}

  interface UserInfo {
    id: number;
    username: string;
    token: string;
    user_id: number;
    role?: string;
  }
  const getStatusLabel = (statusCode: number): string => {
    switch (statusCode) {
      case WorkOrderStatus.Paid:
        return "Paid";
      case WorkOrderStatus.Cancel:
        return "Canceled";
      case WorkOrderStatus.Pending:
        return "Pending";
        case WorkOrderStatus.Initiated:
          return "Initiated";
      default:
        return "Unknown Status";
    }
  };
  
  const getStatusColor = (statusCode: number): string => {
    switch (statusCode) {
      case WorkOrderStatus.Paid:
        return "#4caf50";
      case WorkOrderStatus.Cancel:
        return "#f44336";
      case WorkOrderStatus.Pending:
        return "#ff9800";
          case WorkOrderStatus.Initiated:
    return "#2196f3"
      default:
        return "#9e9e9e";
    }
  };

  type TabKey = "scan" | "registrants" | "overview" | "manual";

const TABS: { key: TabKey; label: string; icon: JSX.Element }[] = [
  { key: "scan", label: "Scan", icon: <QrCodeScannerIcon /> },
  { key: "registrants", label: "Registrants", icon: <PeopleIcon /> },
  { key: "overview", label: "Overview", icon: <InsightsIcon /> },
  { key: "manual", label: "Manual", icon: <EditIcon /> }, 
];


const Scan: React.FC = () => {
  const classes = useStyles();
  const { id: ProductId } = useParams<{ id: string }>();
  const [ticket, setTicket] = useState<Ticket | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [scanResult, setScanResult] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const [qrLoading, setQrLoading] = useState(true);
  const [scanning, setScanning] = useState(false);
//   const navigate = useNavigate();
const scannedRef = useRef(false);
// const location = useLocation();
const [lastScannedToken, setLastScannedToken] = useState<string | null>(null);
const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
const [activeTab, setActiveTab] = useState<"scan" | "registrants" | "overview" | "manual">("scan");
const [orderTickets, setOrderTickets] = useState<IOrderTicket[]>([]);
const [loadingRegistrants, setLoadingRegistrants] = useState(true);
const [selectedStatus, setSelectedStatus] = useState<string>("");
const [dateFilter, setDateFilter] = useState<string>("");
const [startDate, setStartDate] = useState<string>("");
const [endDate, setEndDate] = useState<string>("");
const [searchQuery, setSearchQuery] = useState("");
const [submitQuery, setSubmitQuery] = useState("");
const [rowsPerPage, setRowsPerPage] = useState(50);
const [page, setPage] = useState(0);
const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
const [scannedBy, setScannedBy] = useState<string>("");
const [scannedAt, setScannedAt] = useState<string>("");
const [scannedGate, setScannedGate] = useState<string>("");
const [scanFilter, setScanFilter] = useState<"all" | "full" | "pending">("all");
const resultRef = useRef<HTMLDivElement | null>(null);


const [hasSubmitted, setHasSubmitted] = useState(false);

 const { showErrorMessage, showMessage } = useNotifier();
   useEffect(() => {}, [ProductId]);



const { data, isLoading, isError, refetch } = useGetProductQuery({
   productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    createdDate: null,
    id: null,
  });


   const product = useMemo(() => {
      if (data && Array.isArray(data.data) && data.data.length > 0) {
        return data.data[0] as IProductPopUP;
      }
      return null;
    }, [data]);



 const fetchRegistrants = async (searchText = "") => {
    try {
      const res = await axios.get(`${API_URL}/order-ticket`, 
        {
           params: {
        searchText,
      },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      });
       setOrderTickets(res.data.data || []);

    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRegistrants(false);
    }
  };

    const handleTabClick = (tab: TabKey) => {
    setActiveTab(tab);
    if (tab === "registrants" && orderTickets.length === 0) {
      fetchRegistrants(); // fetch only once
    }
    else if (tab === "manual") {
    setHasSubmitted(false); // reset manual tab
    setSubmitQuery("");     // optional: clear search
  }
  };

//      useEffect(() => {
//   const delay = setTimeout(() => {
//     fetchRegistrants(searchQuery);
//   }, 400); // 400ms debounce

//   return () => clearTimeout(delay);
// }, [searchQuery]);

useEffect(() => {
  if (activeTab !== "registrants") return;

  // Fetch once immediately
  fetchRegistrants(searchQuery);

  // Debounce search query
  const debounce = setTimeout(() => {
    fetchRegistrants(searchQuery);
  }, 400);

  // Auto refresh every 10 seconds
  const interval = setInterval(() => fetchRegistrants(searchQuery), 10000);

  return () => {
    clearTimeout(debounce);
    clearInterval(interval);
  };
}, [activeTab, searchQuery]);


useEffect(() => {
  if (activeTab === "registrants") {
    const interval = setInterval(fetchRegistrants, 10000);
    return () => clearInterval(interval);
  }
}, [activeTab]);


useEffect(() => {
  if (activeTab !== "scan") return;

  setTimeout(() => {
    resultRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }, 200);
}, [scanResult, activeTab]);


  

  const totalTickets = orderTickets?.reduce((sum, t) => sum + t.booked_quantity, 0) ?? 0;

// total used tickets
const totalUsed = orderTickets?.reduce((sum, t) => sum + t.used_quantity, 0) ?? 0;

// remaining tickets
const totalRemaining = totalTickets - totalUsed;

// total events
const eventsMap: Record<
  number,
  {
    id: number;
    name: string;
    totalBooked: number;
    totalUsed: number;
  }
> = {};

orderTickets?.forEach((t) => {
  if (!eventsMap[t.event_id]) {
    eventsMap[t.event_id] = {
      id: t.event_id,
      name: t.event_name || "N/A",
      totalBooked: 0,
      totalUsed: 0,
    };
  }

  eventsMap[t.event_id].totalBooked += t.booked_quantity || 0;
  eventsMap[t.event_id].totalUsed += t.used_quantity || 0;
});

const events = Object.values(eventsMap);

  const filteredInvoice = orderTickets?.filter((row) => {
   
    
      const matchesDate =
    !dateFilter ||
    (() => {
      if (!row.created_at) return false;

      const createdDate = new Date(row.created_at).toLocaleDateString("en-CA");
      const startDateString = new Date(startDate).toLocaleDateString("en-CA");
      const endDateString = new Date(endDate).toLocaleDateString("en-CA");

      return createdDate >= startDateString && createdDate <= endDateString;
    })();

  //   const matchesStatus =
  // selectedStatus !== "" && selectedStatus !== undefined
  //   ? row.quoteWorkOrderStatus === Number(selectedStatus)
  //   : true;

      return  matchesDate;
    });

      const handleScan = async (scannedToken: string | null) => {
    if (!scannedToken) return;

      if (scanning) return;
     setScanning(true);

    try {
      const res = await axios.get(`${API_URL}/scan-ticket/${scannedToken}`, {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  },
});
   
setScanResult(`✅ ${res.data.message}. Remaining: ${res.data.remaining}`);
 setTicket(res.data.ticket);
 setScannedBy(res.data.scanned_by);
 setScannedAt(res.data.scanned_at);
 setScannedGate(res.data.scanned_gate); 
 //fetchRegistrants(); if date is small use this otherwise below code

 setOrderTickets((prev) =>
  prev.map((t) =>
    t.id === res.data.ticket.id
      ? { ...t, used_quantity: res.data.ticket.used_quantity }
      : t
  )
);
  // playSuccessSound();
 //if (navigator.vibrate) navigator.vibrate([100, 50, 100]);
    } catch (err: any) {
      console.error(err);
     if (err.response) {

    setScanResult(`❌ ${err.response.data.message}`);
    setTicket(err.response.data.ticket);
  } else {
    setScanResult(`❌ Error validating ticket`);
  }
    }
    finally {
    setScanning(false);
  }
  };

    const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };



  const visibleInvoices = filteredInvoice.filter((row: IOrderTicket) => {
  const booked = row.booked_quantity ?? 0;
  const used = row.used_quantity ?? 0;

  if (scanFilter === "full") return used === booked;
  if (scanFilter === "pending") return used < booked;
  return true; // all
});

// const playSuccessSound = () => {
//   const audio = new Audio("/success.mp3");
//   audio.play();
// };

 // if (loading) return <p>Loading ticket details...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (



    
    <><div style={{ maxWidth: 500, margin: "10px auto", textAlign: "center", fontFamily: "Arial, sans-serif", border: "1px solid #ddd", padding: 20, borderRadius: 8, backgroundColor: 'white' }}>

  <img
                src={LogoMain}
                alt="Logo"
                style={{ width: 70, marginTop: 10 }} />

              <h1 style={{ marginBottom: 15 }}>{product?.productName || ""}</h1>

      {activeTab === "scan" && (
        <>
        
            
              {/* <h3>Scan QR Code</h3> */}
             
              <div
                style={{
                  width: "100%",
                  maxWidth: 280,
                  margin: "0 auto 15px",
                  borderRadius: 12,
                  // overflow: "hidden",
                  // boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                }}
              >
            
                <QrReader
                  constraints={{ facingMode: "environment" }}
                  onResult={(result: any, error: any) => {
                    if (!result) return;

                    const token = result.text;

                    // ignore if same as last scanned
                    if (token === lastScannedToken) return;

                    if (!scannedRef.current) {
                      scannedRef.current = true;
                      setLastScannedToken(token); // store last token
                      handleScan(token);
                    }

                    if (!!error) {
                      // optionally log or ignore
                    }
                  } }
                  style={{ width: "100%" }} />
              </div>

                <h1 style={{ marginBottom: 20 }}>  {dayjs(
                product?.loopingDetails?.tableColumns?.find(
                  (col) => col.name === "eventStartDate"
                )?.value
              ).isValid()
                ? dayjs(
                  product?.loopingDetails?.tableColumns?.find(
                    (col) => col.name === "eventStartDate"
                  )?.value
                ).format("MMM D, YYYY")
                : "-"}</h1>

       


{scanResult && (
  <>
    {/* Scan Again Button */}
    <Button
      className={classes.addButton}
      variant="contained"
      sx={{
        mb: 2,
        mx: "auto",
      }}
      onClick={() => {
        scannedRef.current = false;
        setScanning(false);
        setScanResult("");
        setTicket(null);
        setLastScannedToken(null);
      }}
    >
      Scan
    </Button>

    {/* Result Box */}
<div ref={resultRef}>
    <Box
      sx={{
        mt: 2,
        mb: 2,
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        color: "#fff",
        background: scanResult.startsWith("✅")
          ? "linear-gradient(135deg, #1B8F3A, #2EBE63)"
          : "linear-gradient(135deg, #B71C1C, #E53935)",
        boxShadow: "0px 12px 30px rgba(0,0,0,0.25)",
        maxWidth: { xs: "97%", sm: 440 },
        mx: "auto",
      }}
    >
      {ticket ? (
        <>
          {/* Row 1: Customer + Entry Pass */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
          
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flex: 1,
                // minWidth: 0,
              }}
            >
              <PersonOutlineIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, sm: 18 },
                  mt: { xs: "2px", sm: 0 }, // mobile alignment fix
                }}
              />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 11.5, sm: 16 },
                  color: "#fff",
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // whiteSpace: "nowrap",
                  lineHeight: 1.25, // key alignment fix
                }}
              >
                {ticket.customer_name}
              </Typography>
            </Box>

            <Box
              sx={{
                // mt: { xs: 1, sm: 0 },
                px: 1,
                py: { xs: 0.4, sm: 0.6 },
                borderRadius: 1,
                backgroundColor: "rgba(0,0,0,0.25)",
                fontSize: { xs: 9.5, sm: 13 },
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {ticket.booked_quantity} ENTRY PASS
            </Box>
          </Box>

          {/* Divider */}
          <Box
            sx={{
              my: { xs: 1.5, sm: 2 },
              borderTop: "2px dashed rgba(204, 201, 201, 0.9)",
            }}
          />

          {/* Row 2: Used / Total */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ fontSize: 18, display: "flex", alignItems: "center" }}>✔</Box>
            <Typography
              sx={{
                fontSize: { xs: 13, sm: 15 },
                fontWeight: 500,
                lineHeight: 1.25,
              }}
            >
              {ticket.booked_quantity} / {ticket.used_quantity} USED
            </Typography>
          </Box>

          {/* Row 3: Date & Time */}
          {scannedAt && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                flexWrap: "wrap",
              }}
            >
              <EventIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, sm: 18 },
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: 12, sm: 14 },
                  lineHeight: 1.25,
                }}
              >
                {dayjs(scannedAt).format("DD/MM/YYYY")} &nbsp;|&nbsp;
                {dayjs(scannedAt).format("hh:mm A")}
              </Typography>
            </Box>
          )}

          {/* Divider */}
          <Box
            sx={{
              my: { xs: 1.5, sm: 2 },
              borderTop: "2px dashed rgba(204, 201, 201, 0.9)",
            }}
          />

          {/* Bottom Pills */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
              {scannedGate && (
            <Box
              sx={{
                px: 1,
                py: 0.3,
                borderRadius: 1,
                backgroundColor: "#F5F5F5",
                color: "#333",
                fontSize: { xs: 9, sm: 12 },
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
              }}
            >
              {scannedGate.toUpperCase()}
            </Box>
              )}
              
            {scannedBy && (
              <Box
                sx={{
                  px: 1,
                  py: 0.3,
                  borderRadius: 1,
                  backgroundColor: "#F5F5F5",
                  color: "#333",
                  fontSize: { xs: 9, sm: 12 },
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                DEVICE LOGGED {scannedBy?.toUpperCase()}
              </Box>
            )}
          </Box>
        </>
      ) : (
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 16 },
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {scanResult}
        </Typography>
      )}
      
    </Box>
    </div>
  </>
)}












              
            

              {/* <button  onClick={handleScan}>scan</button> */}


            </>

         

        
      )}


      {activeTab === "registrants" && (


        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              {/* <Grid item lg={2} md={2} sm={2} xs={12} pt={2} alignContent={"center"}>
                <Typography className={classes.cardTitle}>Registrants</Typography>
              </Grid> */}
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{
                    display: "flex",
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    gap: 1,
                  }}
                >
                  {/* <Grid item lg={2} md={2} sm={4} xs={12}>
                      
       <Select
         // label="Status"
         className={classes.textField}
         value={selectedStatus || ""}
         onChange={(event) => setSelectedStatus(event.target.value)}
         displayEmpty
         sx={{
           height: "37px",
           fontSize: "14px",
           padding: "4px",
           minWidth: "120px"
         }}
       >
      <MenuItem value="">All Status</MenuItem>
     
       {WorkOrderStatus && Object.keys(WorkOrderStatus).length > 0 ? (
         Object.entries(WorkOrderStatus).map(([key, value], index) => (
           <MenuItem key={index} value={String(value)}>
             {key}
           </MenuItem>
         ))
       ) : (
         <MenuItem disabled>No data available</MenuItem>
       )}
           
      
       </Select>
     
                   </Grid> */}

                  {/* <Grid item lg={2} md={2} sm={4} xs={12}>
   <Select
   //  label="Date"
    className={classes.textField}
    value={dateFilter}
    onChange={(e) => setDateFilter(e.target.value)}
    displayEmpty
   
    sx={{
     height: "37px",
     fontSize: "14px",
     padding: "4px",
     minWidth: "120px"
   }}
  >
    <MenuItem value="">Select date filter</MenuItem>
    <MenuItem value="today">Today</MenuItem>
    <MenuItem value="yesterday">Yesterday</MenuItem>
    <MenuItem value="this_week">This Week</MenuItem>
    <MenuItem value="last_week">Last Week</MenuItem>
    <MenuItem value="this_month">This Month</MenuItem>
    <MenuItem value="last_month">Last Month</MenuItem>
    <MenuItem value="custom">Custom</MenuItem>
  </Select>
</Grid> */}

                  {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
                  {/* {dateFilter === "custom" && (
              <>
                <Grid item lg={2} md={2} sm={4} xs={12}>
                
                  <TextField
                   label="Start Date"
                   variant="outlined"
                    type="date"
                    size="small"
                   className={classes.textField}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    
                  />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={12}>
                  
                  <TextField
                  label="End Date"
                    type="date"
                    size="small"
                   className={classes.textField}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
             
                  />
                </Grid>
              </>
            )} */}




                  <Grid item>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Invoice No .."
                      sx={{ width: "100%" }}
                      size="small" />
                  </Grid>

            

                </Grid>
              </Grid>
            </Grid>

            <Grid>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      {/* <TableCell className={classes.tablheader}>
              <CustomCheckbox name="checkbox" />
            </TableCell> */}
                      <TableCell className={classes.tablheader}>
                        <strong>#</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Invoice No</strong>
                      </TableCell>
                      {/* <TableCell className={classes.tablheader}>
             <strong>Mode/Date</strong>
           </TableCell> */}

                      <TableCell className={classes.tablheader}>
                        <strong>Customer</strong>
                      </TableCell>
                      {/* <TableCell className={classes.tablheader}>
              <strong>Mode</strong>
            </TableCell> */}
                      {/* <TableCell className={classes.tablheader}>
              <strong>Status</strong>
            </TableCell> */}
                      <TableCell className={classes.tablheader}>
                        <strong>Description</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Qty</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Used</strong>
                      </TableCell>
                      {/* <TableCell className={classes.tablheader}>
              <strong>Amount</strong>
            </TableCell>
            <TableCell className={classes.tablheader}>
              <strong>Paid Amt</strong>
            </TableCell> */}
                      {/* <TableCell className={classes.tablheader}>
             <strong>Date</strong>
           </TableCell> */}
                      {/* <TableCell className={classes.tablheader}>
              <strong>Balance</strong>
            </TableCell> */}


                      {/* <TableCell className={classes.tablheader}>
              <strong>Issue From</strong>
            </TableCell> */}




                      {/* <TableCell className={classes.tablheader}>
              <strong>Status</strong>
            </TableCell> */}
                      {/* <TableCell
              className={classes.tablheader}
               sx={{ textAlign: "right" ,'@media print': {
                  display: 'none',
                } }}
            >
              <strong>Actions</strong>
            </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isError || filteredInvoice.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {isError ? "Error fetching data" : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredInvoice
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row: IOrderTicket, index) => {

                          return (
                            <TableRow key={row.id} className={classes.tableRowHover}>
                              {/* <TableCell className={classes.tablCell}>
                              <CustomCheckbox name="checkbox" />
                            </TableCell> */}

                              <TableCell scope="row" className={classes.tablCell}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                className={classes.tablCell}
                                sx={{ whiteSpace: "nowrap", cursor: "pointer" }} // Prevents line break & makes it clickable

                              >
                                {/* <Link  to={`/work-order/history/${row.work_order_id}`} // Replace with the correct path to your desired page
                            style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
                             */}
                                {row.invoice_no}
                                &nbsp;

                                {/* </Link> */}
                              </TableCell>
                              {/* <TableCell scope="row" className={classes.tablCell}>
                                                      {row.Mode} / {row?.created_at ? dayjs(row.created_at).format("DD-MMM-YY, hh:mm A")
                                                                                            : ""}
                                          
                            
                                                    </TableCell> */}


                              <TableCell scope="row" className={classes.tablCell}>



                                {/* <Link
                     to={`/customer-history/${row.quoteWorkOrderCustomerId}`} // Replace with the correct path to your desired page
                     style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
*/}
                                {row.customer_name}

                                {/* </Link>     */}


                              </TableCell>

                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                {row.event_name}
                              </TableCell>



                              {/* <TableCell scope="row" className={classes.tablCell}>
                                                   <Button
                                                                               className={classes.statusButtonList}
                                                                               style={{
                                                                                 color: statusColor,
                                                                                 backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                                                 ? "#e1f8d5"
                                                                                 : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                                                 ? "#f8d7da"
                                                                                 : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                                                 ? "lightyellow"
                                                                                   : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                                                 ? "#e2fafa"
                                                                                 : "#ffffff", // Fallback for other statuses
                                                                                 border: "solid 1px",
                                                                                 borderColor: statusColor,
                                                                                 borderRadius: "8px",
                                                                                 
                                                                               }}
                                                                             >
                                                                               {statusLabel}
                                                                             </Button>
                                                 </TableCell> */}

                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                {row.booked_quantity ?? '-'}
                              </TableCell>
                              {/* <TableCell component="th" scope="row" className={classes.tablCell}>
                            {row.used_quantity ?? '-'}
                            </TableCell> */}
                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center", // vertically center the number and button
                                    justifyContent: "flex-start", // align to left
                                    gap: 1, // spacing between number and button
                                  }}
                                >
                                  {/* Current used quantity */}
                                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {row.used_quantity ?? 0}
                                  </Typography>

                                  {/* Edit button */}
                                  {/* <Button
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    sx={{
                                      minWidth: 40,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      textTransform: "none",
                                    }}
                                    endIcon={<ArrowDropDownIcon />}
                                    onClick={(e) => {
                                      setAnchorEl(e.currentTarget);
                                      setSelectedRowId(row.id);
                                    } }
                                  >
                                    Edit
                                  </Button>

                                
                                  <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl) && selectedRowId === row.id}
                                    onClose={() => setAnchorEl(null)}
                                    MenuListProps={{
                                      sx: { padding: 0 }, // remove default padding for neatness
                                    }}
                                  >
                                    {Array.from({ length: row.booked_quantity + 1 }).map((_, index) => (
                                      <MenuItem
                                        key={index}
                                        selected={index === row.used_quantity}
                                        sx={{
                                          minWidth: 60,
                                          justifyContent: "center",
                                          fontSize: "0.85rem",
                                        }}
                                        onClick={async () => {
                                          try {
                                            const res = await axios.put(
                                              `${API_URL}/order-ticket/${row.id}/update-used`,
                                              { used_quantity: index },
                                              {
                                                headers: {
                                                  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
                                                },
                                              }
                                            );

                                            
                                            if (res.status) {
                                             
                                              showMessage("Used quantity updated");
                                            }
                                            fetchRegistrants(); // refresh table after update
                                          } catch (err) {
                                            showErrorMessage("Failed to update the used quantity");
                                            console.error(err);

                                          } finally {
                                            setAnchorEl(null);
                                          }
                                        } }
                                      >
                                        {index}
                                      </MenuItem>
                                    ))}
                                  </Menu> */}
                                </Box>
                              </TableCell>




                              {/* <TableCell component="th" scope="row" className={classes.tablCell}>
                                 {row?.created_at ? dayjs(row.created_at).format("DD-MMM-YY, hh:mm A")
                                                                        : ""}
                                 </TableCell> */}


                              {/* <TableCell scope="row" className={classes.tablCell}>
                              {row.company.companyName || row.project.projectName || ""}
                           
                            </TableCell> */}


                              {/* <TableCell scope="row" className={classes.tablCell}>
                              <Button
                                className={classes.statusButtonList}
                                style={{
                                  color: statusColor,
                                  border: "solid 1px",
                                  borderColor: statusColor,
                                  borderRadius: "8px",
                                }}
                              >
                                {statusLabel}
                              </Button>
                            </TableCell> */}
                              {/* <TableCell scope="row" className={classes.tablCell}>
                   
                              <Grid
                                container
                                spacing={1}
                                sx={{ display: "flex", justifyContent: "flex-end" }}
                              >
                                  {row.order_tickets
        ?.filter((ticket) => {
      
          if (activeTab === "product") return true;
          return String(ticket.event_id) === String(activeTab);
        })
        .map((ticket) => {
          const fullyUsed = ticket.used_quantity >= ticket.booked_quantity;
             return (
     <Grid item>
                             <Tooltip title={fullyUsed ? "Fully Scanned" : "Scan Ticket"}>
               <span>
              <Button
                variant="contained"
                className={classes.viewButtonList}
                onClick={() => !fullyUsed && window.open(`/scan/${ticket.qr_token}`, "_blank")}
                disabled={fullyUsed}
              >
                {fullyUsed ?  <CheckCircleIcon  sx={{ color: "#2e7d32" }} />  : <QrCodeScannerIcon />}
              </Button>
              </span>
            </Tooltip>
                          </Grid>
                           );
      })}                */}


                              {/* <Grid item  sx={{ '@media print': {
                       display: 'none',
                     } }}>
                               <Button
                                 variant="contained"
                                 className={classes.viewButtonList}
                                 onClick={() =>
                                   navigate(`/invoice/history/${row.id}`)
                                 }
                               >
                                 <DescriptionIcon
                                   className={classes.viewListIcon}
                                 />
                               </Button>
                             </Grid> */}




                              {/* </Grid>
                          </TableCell> */}
                            </TableRow>
                          );
                        })
                    )}
                  </TableBody>
                </Table>
                <Grid
                  spacing={5}
                  p={"18px"}
                  py={4}
                  justifyContent={"end"}
                  container
                  textAlign={"center"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Grid
                    sx={{
                      textAlign: "end",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Pagination
                      count={filteredInvoice.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage} />
                  </Grid>
                </Grid>
              </TableContainer>
              {/* {openCreateVariantDialog && (
              <CreateVariantPopUp
                openModel={openCreateVariantDialog}
                handleCloseDialog={handleCreateCloseDialog}
                productId={String(ProductId)}
                 productCategoryId={String(mappedCategoryId)} />
            )}
            {selectedProduct && (
              <EditVariantPopUp
                openModel={openDialog}
                handleCloseDialog={handleCloseDialog}
                data={selectedProduct} />
            )}
            {productToDelete && (
              <DeletePopup
                open={openDeleteProduct}
                handleCloseDelete={handleCloseDeletePopup}
                onConfirm={async () => {
                  await handleDelete(productToDelete.id.toString());
                } }
                title="Delete Product"
                content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
            )} */}
            </Grid>
          </Card>


        </Grid>
      )}



       {activeTab === "manual" && (


        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ padding: 1 }}
              className={classes.titleGrid}
            >
              {/* <Grid item lg={2} md={2} sm={2} xs={12} pt={2} alignContent={"center"}>
                <Typography className={classes.cardTitle}>Registrants</Typography>
              </Grid> */}
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{
                    display: "flex",
                    // flexWrap: { xs: "wrap", md: "nowrap" },
                      flexWrap: "nowrap",
                    gap: 1,
                  }}
                >
                
                  <Grid item  lg={12}
                md={12}
                sm={12}
                xs={12}>
                    <TextField
                      // InputProps={{
                      //   startAdornment: (
                      //     <InputAdornment position="start">
                      //       <CiSearch className={classes.searchWidgetIcon} />
                      //     </InputAdornment>
                      //   ),
                      //   classes: {
                      //     root: classes.formControlList,
                      //   },
                      // }}
                      fullWidth
                      value={submitQuery}
                      onChange={(e) => setSubmitQuery(e.target.value)}
                      placeholder="Invoice No .."
                      sx={{ width: "100%" }}
                      size="small" />
                  </Grid>

 <Grid item>  
             <Button
               variant="contained"
              //  startIcon={<EmailIcon />}
               className={classes.addButton}
              onClick={() => {
                setHasSubmitted(true);  
    fetchRegistrants(submitQuery.trim());
  }}
              //  disabled={!dataLoaded}
             >
               Submit
             </Button>
      
       </Grid>

                </Grid>
              </Grid>
            </Grid>

            <Grid>
              {hasSubmitted ? (
             <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    minHeight: '60vh',
    gap: 2,
    mt:2,mb:2,
    px: { xs: 0, sm: 0 },
  }}
>
  {isError || filteredInvoice.length === 0 ? (
    <Typography align="center">
      {isError ? "Error fetching data" : "No data available"}
    </Typography>
  ) : (
    filteredInvoice
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((row: IOrderTicket, index) => (
        <Box
          key={row.id}
          sx={{
            p: 2,
            borderRadius: 2,
            color: "#fff",
            background: "linear-gradient(135deg, #1B8F3A, #2EBE63)",
            boxShadow: "0px 10px 25px rgba(0,0,0,0.25)",
          }}
        >
          {/* Top Row */}
         <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
          
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flex: 1,
                // minWidth: 0,
              }}
            >
              <PersonOutlineIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, sm: 18 },
                  mt: { xs: "2px", sm: 0 }, // mobile alignment fix
                }}
              />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 11.5, sm: 16 },
                  color: "#fff",
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // whiteSpace: "nowrap",
                  lineHeight: 1.25, // key alignment fix
                }}
              >
                {row.customer_name}
              </Typography>
            </Box>

            <Box
              sx={{
                // mt: { xs: 1, sm: 0 },
                px: 1,
                py: { xs: 0.4, sm: 0.6 },
                borderRadius: 1,
                backgroundColor: "rgba(0,0,0,0.25)",
                fontSize: { xs: 9.5, sm: 13 },
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {row.booked_quantity} ENTRY PASS
            </Box>
          </Box>

          {/* Divider */}
          <Box
            sx={{
              my: { xs: 1.5, sm: 2 },
              borderTop: "2px dashed rgba(204, 201, 201, 0.9)",
            }}
          />

          <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                mb: 1,
                flexWrap: "wrap",
              }}
            >
              <EventIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, sm: 18 },
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: 12, sm: 14 },
                  lineHeight: 1.25,
                }}
              >
               {row.invoice_no} &nbsp;|&nbsp; {row.event_name}
              </Typography>
            </Box>

          {/* Row 2: Used / Total */}

          <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    flexWrap: "nowrap",
  }}
>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ fontSize: 18, display: "flex", alignItems: "center" }}>✔</Box>
            <Typography
              sx={{
                fontSize: { xs: 13, sm: 15 },
                fontWeight: 500,
                lineHeight: 1.25,
              }}
            >
              {row.booked_quantity} / {row.used_quantity} USED
            </Typography>
          </Box>

           <Button
    size="small"
    variant="contained"
    endIcon={<ArrowDropDownIcon />}
    sx={{
      backgroundColor: "rgba(0,0,0,0.25)",
      fontSize: { xs: 10, sm: 12 },
      textTransform: "none",
      height: 26,
      px: 1,
      minWidth: 60,
      flexShrink: 0,
       '&:hover': {
      backgroundColor: "rgba(0,0,0,0.25)",
    },
    '&:active': {
      backgroundColor: "rgba(0,0,0,0.25)",
    },
    '&.Mui-focusVisible': {
      backgroundColor: "rgba(0,0,0,0.25)",
    },
    }}
    onClick={(e) => {
      setAnchorEl(e.currentTarget);
      setSelectedRowId(row.id);
    }}
  >
    Edit
  </Button>

  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl) && selectedRowId === row.id}
    onClose={() => setAnchorEl(null)}
  >
    {Array.from({ length: row.booked_quantity + 1 }).map((_, index) => (
      <MenuItem
        key={index}
        selected={index === row.used_quantity}
        onClick={async () => {
          try {
           const res =  await axios.put(
              `${API_URL}/order-ticket/${row.id}/update-used`,
              { used_quantity: index },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
                },
              }
            ); 
            if (res.data.status) {
      showMessage("Used quantity updated");
// fetchRegistrants(submitQuery.trim());
          setOrderTickets((prev) =>
        prev.map((row) =>
          row.id === selectedRowId
            ? {
                ...row,
                used_quantity: res.data.ticket.used_quantity,
                scannedUser: res.data.scanned_by,
                scannedDate: res.data.scanned_at,
                scannedGate: res.data.scanned_gate, 
              }
            : row
        )
      );
    }
            
            
          } catch {
            showErrorMessage("Failed to update");
          } finally {
            setAnchorEl(null);
          }
        }}
      >
        {index}
      </MenuItem>
    ))}
  </Menu>
</Box>

          {/* Row 3: Date & Time */}
          {row.scannedDate  && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                flexWrap: "wrap",
              }}
            >
              <EventIcon
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, sm: 18 },
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: 12, sm: 14 },
                  lineHeight: 1.25,
                }}
              >
                {dayjs(row.scannedDate).format("DD/MM/YYYY")} &nbsp;|&nbsp;
                {dayjs(row.scannedDate).format("hh:mm A")}
              </Typography>
            </Box>
          )}

          {/* Divider */}
          <Box
            sx={{
              my: { xs: 1.5, sm: 2 },
              borderTop: "2px dashed rgba(204, 201, 201, 0.9)",
            }}
          />

          {/* Bottom Pills */}
       
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
               {row.scannedGate && (
            <Box
              sx={{
                px: 1,
                py: 0.3,
                borderRadius: 1,
                backgroundColor: "#F5F5F5",
                color: "#333",
                fontSize: { xs: 9, sm: 12 },
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
              }}
            >
              {row.scannedGate.toUpperCase()}
            </Box>
               )}

            {row.scannedUser && (
              <Box
                sx={{
                  px: 1,
                  py: 0.3,
                  borderRadius: 1,
                  backgroundColor: "#F5F5F5",
                  color: "#333",
                  fontSize: { xs: 9, sm: 12 },
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                DEVICE LOGGED {row.scannedUser?.toUpperCase()}
              </Box>
            )}
          </Box>
        </Box>
      ))
  )}

  {/* Pagination */}
  {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
    <Pagination
      count={Math.ceil(filteredInvoice.length / rowsPerPage)}
      page={page + 1}
      onChange={(e, value) => handleChangePage(e, value - 1)}
    />
  </Box> */}
</Box>

  ): (
     <Box
  sx={{
    display: "flex",
    minHeight:'40vh',
    flexDirection: "column",
    gap: 2,
    px: { xs: 0, sm: 0 },
  }}
></Box>
  )}        
            </Grid>
          </Card>


        </Grid>
      )}

      {activeTab === "overview" && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            {/* Summary Cards */}
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent>
                  <Grid container direction="column" alignItems="center">
                    <Typography variant="h5" mt={2}>Total Tickets</Typography>
                    <Typography
                      variant="h3"
                      sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                    >
                      {totalTickets}
                    </Typography>
                  </Grid>
                </CardContent>

              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent>
                  <Grid container direction="column" alignItems="center">
                    <Typography variant="h5" mt={2}>Used Tickets</Typography>
                    <Typography
                      variant="h3"
                      sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                    >
                      {totalUsed}
                    </Typography>
                  </Grid>
                </CardContent>
                {/* <Typography>Used Tickets</Typography>
            <Typography variant="h5">{totalUsed}</Typography> */}
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card elevation={3}>
                <CardContent>
                  <Grid container direction="column" alignItems="center">
                    <Typography variant="h5" mt={2}>Remaining</Typography>
                    <Typography
                      variant="h3"
                      sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                    >
                      {totalRemaining}
                    </Typography>
                  </Grid>
                </CardContent>
                {/* <Typography>Remaining Tickets</Typography>
            <Typography variant="h5">{totalRemaining}</Typography> */}
              </Card>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <Card>
                <Typography>Total Events</Typography>
                <Typography variant="h5">{totalEvents}</Typography>
              </Card>
            </Grid> */}

            {/* Tickets by Event */}
            <Grid item xs={12}>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}><strong>Event</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>Total Tickets</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>Used</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>Remaining</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {events.map((e) => (
                      <TableRow key={e.id} className={classes.tableRowHover}>
                        <TableCell component="th" scope="row" className={classes.tablCell}>{e.name}</TableCell>
                        <TableCell component="th" scope="row" className={classes.tablCell}>{e.totalBooked}</TableCell>
                        <TableCell component="th" scope="row" className={classes.tablCell}>{e.totalUsed}</TableCell>
                        <TableCell component="th" scope="row" className={classes.tablCell}>{e.totalBooked - e.totalUsed}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>



  <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid item lg={2} md={2} sm={2} xs={12} pt={2} alignContent={"center"}>
                <Typography className={classes.cardTitle}>Tickets</Typography>
              </Grid>
              <Grid
                item
                lg={10}
                md={10}
                sm={10}
                xs={10}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{
                    display: "flex",
                    flexWrap: { xs: "wrap", md: "nowrap" },
                    gap: 1,
                  }}
                >
                  {/* <Grid item lg={2} md={2} sm={4} xs={12}>
                      
       <Select
         // label="Status"
         className={classes.textField}
         value={selectedStatus || ""}
         onChange={(event) => setSelectedStatus(event.target.value)}
         displayEmpty
         sx={{
           height: "37px",
           fontSize: "14px",
           padding: "4px",
           minWidth: "120px"
         }}
       >
      <MenuItem value="">All Status</MenuItem>
     
       {WorkOrderStatus && Object.keys(WorkOrderStatus).length > 0 ? (
         Object.entries(WorkOrderStatus).map(([key, value], index) => (
           <MenuItem key={index} value={String(value)}>
             {key}
           </MenuItem>
         ))
       ) : (
         <MenuItem disabled>No data available</MenuItem>
       )}
           
      
       </Select>
     
                   </Grid> */}

                  {/* <Grid item lg={2} md={2} sm={4} xs={12}>
   <Select
   //  label="Date"
    className={classes.textField}
    value={dateFilter}
    onChange={(e) => setDateFilter(e.target.value)}
    displayEmpty
   
    sx={{
     height: "37px",
     fontSize: "14px",
     padding: "4px",
     minWidth: "120px"
   }}
  >
    <MenuItem value="">Select date filter</MenuItem>
    <MenuItem value="today">Today</MenuItem>
    <MenuItem value="yesterday">Yesterday</MenuItem>
    <MenuItem value="this_week">This Week</MenuItem>
    <MenuItem value="last_week">Last Week</MenuItem>
    <MenuItem value="this_month">This Month</MenuItem>
    <MenuItem value="last_month">Last Month</MenuItem>
    <MenuItem value="custom">Custom</MenuItem>
  </Select>
</Grid> */}

                  {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
                  {/* {dateFilter === "custom" && (
              <>
                <Grid item lg={2} md={2} sm={4} xs={12}>
                
                  <TextField
                   label="Start Date"
                   variant="outlined"
                    type="date"
                    size="small"
                   className={classes.textField}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    
                  />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={12}>
                  
                  <TextField
                  label="End Date"
                    type="date"
                    size="small"
                   className={classes.textField}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
             
                  />
                </Grid>
              </>
            )} */}

<Grid item>
  <ToggleButtonGroup
    size="small"
    exclusive
    value={scanFilter}
    onChange={(_, value) => value && setScanFilter(value)}
    sx={{
      "& .MuiToggleButton-root": {
        textTransform: "none",
        fontSize: 13,
        px: 2,
      },
      "& .Mui-selected": {
           backgroundColor: "#c69c6b",
        color: "white",
        "&:hover": {
          backgroundColor: "#b0895c",
        },
      },
    }}
  >
    <ToggleButton value="all">All</ToggleButton>
    <ToggleButton value="full">Scanned</ToggleButton>
    <ToggleButton value="pending">Pending</ToggleButton>
  </ToggleButtonGroup>
</Grid>




                  {/* <Grid item>
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Invoice No .."
                      sx={{ width: "100%" }}
                      size="small" />
                  </Grid> */}

            

                </Grid>
              </Grid>
            </Grid>

            <Grid>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      {/* <TableCell className={classes.tablheader}>
              <CustomCheckbox name="checkbox" />
            </TableCell> */}
                      <TableCell className={classes.tablheader}>
                        <strong>#</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Invoice No</strong>
                      </TableCell>
                      
                      <TableCell className={classes.tablheader}>
                        <strong>Customer</strong>
                      </TableCell>
                   
                      <TableCell className={classes.tablheader}>
                        <strong>Description</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Qty</strong>
                      </TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Used</strong>
                      </TableCell>
                  
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isError || filteredInvoice.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={20} align="center">
                          {isError ? "Error fetching data" : "No data available"}
                        </TableCell>
                      </TableRow>
                    ) : (
                      visibleInvoices
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row: IOrderTicket, index) => {

                          return (
                            <TableRow key={row.id} className={classes.tableRowHover}>
                              {/* <TableCell className={classes.tablCell}>
                              <CustomCheckbox name="checkbox" />
                            </TableCell> */}

                              <TableCell scope="row" className={classes.tablCell}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                className={classes.tablCell}
                                sx={{ whiteSpace: "nowrap", cursor: "pointer" }} // Prevents line break & makes it clickable

                              >
                              
                                {row.invoice_no}
                                &nbsp;

                                {/* </Link> */}
                              </TableCell>
                            
                              <TableCell scope="row" className={classes.tablCell}>



                                {/* <Link
                     to={`/customer-history/${row.quoteWorkOrderCustomerId}`} // Replace with the correct path to your desired page
                     style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
*/}
                                {row.customer_name}

                                {/* </Link>     */}


                              </TableCell>

                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                {row.event_name}
                              </TableCell>


                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                {row.booked_quantity ?? '-'}
                              </TableCell>
                            
                              <TableCell component="th" scope="row" className={classes.tablCell}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center", // vertically center the number and button
                                    justifyContent: "flex-start", // align to left
                                    gap: 1, // spacing between number and button
                                  }}
                                >
                                  {/* Current used quantity */}
                                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {row.used_quantity ?? 0}
                                  </Typography>

                                
                                </Box>
                              </TableCell>



                            </TableRow>
                          );
                        })
                    )}
                  </TableBody>
                </Table>
                <Grid
                  spacing={5}
                  p={"18px"}
                  py={4}
                  justifyContent={"end"}
                  container
                  textAlign={"center"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Grid
                    sx={{
                      textAlign: "end",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Pagination
                      count={visibleInvoices.length}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      onPageChange={handleChangePage} />
                  </Grid>
                </Grid>
              </TableContainer>
              
            </Grid>
          </Card>


        </Grid>






          </Grid>
        </Grid>
      )}
      {/* Bottom Tabs */}

<Box
    sx={{
      display: "flex",
      backgroundColor: "#fff",
      borderTop: "1px solid #e0e0e0",
      margin: "0 -20px", // negative margins remove parent's padding
      position: "sticky",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 20,
    }}
  >
    {TABS.map((tab) => {
      const isActive = activeTab === tab.key;

      return (
        <Button
          key={tab.key}
          size="small"
          fullWidth
          variant="contained"
          onClick={() => handleTabClick(tab.key)}
          sx={{
            flex: "1 1 33%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textTransform: "none",
            py: "6px",
            borderRadius: 0,
            boxShadow: "none",
           // backgroundColor: isActive ? "#058292" : "#f5f5f5",
            color: isActive ? "#fff" : "#444",
          }}
        >
          {tab.icon}
          <Typography variant="body2" fontWeight="bold">
            {tab.label}
          </Typography>
        </Button>
      );
    })}
  </Box>


    </div></>

    
  );
};

export default Scan;
